import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const Radio = forwardRef((
    /**@type {Omit<Props, 'value'> & Omit<React.InputHTMLAttributes, 'type' | 'name'>} */
    {
        className = '',
        labelClassName,
        errors,
        id: idProp,
        label,
        name,
        value,
        ...remainingProps
    },
    /**@type {React.ForwardedRef<(HTMLInputElement)>} */
    ref
) => {
    const id = idProp ?? `frm-${name}-${value}`;
    return (
        <div
            className={'field inline-block' + (className ? ` ${className}` : '')}>
            <div className='radio-field flex'>
                <input
                    aria-invalid={errors}
                    aria-labelledby={id}
                    className=''
                    id={id}
                    name={name}
                    ref={ref}
                    type='radio'
                    value={value}
                    {...remainingProps} />
                <label
                    className='radio-field__label cursor-pointer flex select-none items-center type-style-s'
                    htmlFor={id}>
                    {label}
                </label>
            </div>
        </div>
    );
});

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    className: PropTypes.string,
    labelClassName: PropTypes.string,
    errors: PropTypes.bool,
    id: PropTypes.string,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
};

Radio.propTypes = propTypes;
Radio.displayName = 'Radio';

export default Radio;
